import { useEffect } from "preact/hooks";
import type { RefObject } from "preact";

export function useDprCanvas(
  canvasRef: RefObject<HTMLCanvasElement | null>,
  logicalWidth: number,
  logicalHeight: number,
): void {
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = logicalWidth * dpr;
    canvas.height = logicalHeight * dpr;
    canvas.style.width = `${logicalWidth}px`;
    canvas.style.height = `${logicalHeight}px`;
    const ctx = canvas.getContext("2d");
    if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }, [canvasRef, logicalWidth, logicalHeight]);
}
